<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="orders.items"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :search="search"
      hide-default-footer
      class="elevation-1 rounded-lg"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.isAvailable="{ item }">
        <v-chip
          label
          :color="`${getColorState(item.isAvailable)} lighten-4`"
          :class="`font-work-sans font-weight-bold ${getColorState(
            item.isAvailable
          )}--text text-uppercase`"
          >{{ getAvailableLabel(item.isAvailable) }}
        </v-chip>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          label
          :color="`${getColorState(item.status)} lighten-4`"
          :class="`font-work-sans font-weight-bold ${getColorState(
            item.status
          )}--text text-uppercase`"
          >{{ getStatusLabel(item.status) }}
        </v-chip>
      </template>
      <template v-slot:item.pdfURL="{ item }">
        <v-btn
          v-if="item.pdfURL"
          icon
          :href="item.pdfURL"
          target="_blank"
          rel="noopener"
        >
          <v-icon small color="red">fa-file-pdf</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >1-{{ itemsPerPage }} de {{ orders.totalItems }}
      </span>
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import Repository from '@/repositories/RepositoryFactory'
import format from 'date-fns/format'
const OrderRepository = Repository.get('orders')

export default {
  name: 'ActiveOrders',
  props: ['search'],
  data: () => ({
    orders: {},
    itemsPerPage: 7,
    pageVisible: 5,
    page: 1,
    pageCount: 0,
    headers: [
      {
        text: 'Id',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'id',
      },
      {
        text: 'Paciente',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient',
      },
      {
        text: 'C.I.',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patientIdNumber',
      },
      {
        text: 'Fecha',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'dateNew',
      },
      {
        text: 'Disponible',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'isAvailable',
      },
      {
        text: 'Estado',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'status',
      },
      {
        text: 'PDF',
        align: 'center',
        class:
          'primary white--text font-weight-bold text-subtitle-2 rounded-tr-lg',
        value: 'pdfURL',
      },
    ],
    itemsPerPages: [7, 10, 20, 30, 50, 100],
  }),
  mounted: async function () {
    await this.loadData()
  },
  methods: {
    loadData: async function () {
      this.$eventBus.emit('loading-page')
      try {
        const res = await OrderRepository.get()
        this.orders = res.data.data
        this.orders.items = Array.from(
          this.orders.items,
          ({ date, patient, ...order }) => ({
            dateNew: format(new Date(date), 'dd-MM-yyyy'),
            patient: `${patient.firstName} ${patient.lastName}`,
            date,
            ...order,
          })
        )
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.removeItem('user')
          location.reload()
        }

        const response = error.response ? error.response.data.message : error

        console.log(response)
      }
    },
    getColorState: (state) => (state ? 'green' : 'red'),
    getAvailableLabel: (state) => (state ? 'Disponible' : 'No disponible'),
    getStatusLabel: (state) => (state ? 'Activo' : 'Inactivo'),
  },
}
</script>
